import { c as _c } from "react/compiler-runtime";
import { classNames, DateTimePicker, FlexColumn, Select, SelectItem, TextBody } from "@opensea/ui-kit";
import { addMinutes } from "date-fns";
import { capitalize } from "es-toolkit/string";
import { useTranslations } from "use-intl";
import { EXPIRATION_IN_MINUTES, MAXIMUM_EXPIRATION_IN_MINUTES } from "../../lib/zod/expiration";
export const ExpirationSelect = t0 => {
  const $ = _c(27);
  const {
    value,
    customDate,
    onCustomDateChange,
    error,
    onChange,
    className,
    overrides
  } = t0;
  const t = useTranslations("wallet.ExpirationSelect");
  let t1;
  if ($[0] !== customDate || $[1] !== error || $[2] !== onCustomDateChange || $[3] !== overrides?.DateTimePicker || $[4] !== t || $[5] !== value) {
    t1 = value === "custom" && <FlexColumn className="col-span-2 items-end gap-1"><DateTimePicker disabled={{
        before: new Date(),
        after: addMinutes(new Date(), MAXIMUM_EXPIRATION_IN_MINUTES)
      }} error={Boolean(customDate && error)} onSelect={date => {
        if (date) {
          onCustomDateChange(date);
        }
      }} portal={false} selected={customDate} {...overrides?.DateTimePicker} className={classNames("grid w-full grid-cols-2 gap-3 md:flex", overrides?.DateTimePicker?.className)} overrides={{
        TimeInput: {
          className: "w-full md:w-fit"
        }
      }} placeholder={t("customExpirationPlaceholder")} />{Boolean(customDate && error) && <TextBody color="error-1" size="xs">{error}</TextBody>}</FlexColumn>;
    $[0] = customDate;
    $[1] = error;
    $[2] = onCustomDateChange;
    $[3] = overrides?.DateTimePicker;
    $[4] = t;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== className) {
    t2 = classNames("md:w-[180px]", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== onChange) {
    t3 = val => {
      onChange(val);
    };
    $[9] = onChange;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = val_0 => {
      const label = Object.entries(EXPIRATION_IN_MINUTES).find(t5 => {
        const [, value_0] = t5;
        return value_0.toString() === val_0;
      })?.[0];
      return <div data-testid="expiration-select">{label ? t(label) : capitalize(val_0)}</div>;
    };
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t || $[14] !== value) {
    t5 = t(value);
    $[13] = t;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t) {
    t6 = Object.keys(EXPIRATION_IN_MINUTES).map(label_0 => <SelectItem key={label_0} value={label_0}>{t(label_0)}</SelectItem>);
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <Select className={t2} onValueChange={t3} renderValue={t4} size="md" value={t5}>{t6}</Select>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t1 || $[25] !== t7) {
    t8 = <>{t1}{t7}</>;
    $[24] = t1;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};